<template>
    <div style="width:350px" class="ma-2">

        <v-dialog v-model="dialog" fullscreen>
            <div style="background-color:white; height:100vh">
               <v-btn class="ma-2" icon @click="dialog=false"><v-icon dark>mdi-arrow-left</v-icon></v-btn>
               <v-divider></v-divider>
               <div align="center">
                <div class="ma-5 pa-5" align="left" style="width:60vw;">
                    <v-row>
                    <v-col cols="6">
                        <p><strong>Rendeltetés</strong></p><p>Mérés-adatgyüjtő rendszerek primer műszereinek külső behatások</p><p>(időjárás, illetéktelen kezelés, idegenkezűség) elleni védelme.</p><p>Kialakítás</p><p>A szekrény felsőrészből (védett, fűtött tér) és alsórészből (lábazat) áll.</p><p>Mindkét rész belső tere elölről - ajtónyitás után - hozzá-férhető.</p><p>A felső szekrényrész háromféle méretben készül:</p><p><br></p><p>MI FC1 típusú 550£390£380mmMm (maxszéxmé)</p><p><br></p><p>HM&nbsp;FC2 típusú 550£550X380mmMm (maxszéxmé)</p><p><br></p><p>HM FC3 típusú 650X850Xx380mmMm (maxszéxmé)</p><p>A lábazat mindhárom nagyságnál azonos méretű 1050£390x250 mm</p><p>(maxszéxm</p>
                    </v-col>
                    <v-col cols="6">
                    <img src="@/assets/images/fc-tip.png" width="500"/>
                    </v-col>
                    </v-row>
                </div>
               </div>
                
            </div>
            
        </v-dialog>

        <v-card height="300px" elevation="2">
            <div class="pa-2" height="40" align="start" style="background-color:#920825;">
                <div class="white--text">{{product_name}}</div>
            </div>
            <v-row class="container">
                <v-col justify="start">
                   <div align="start" style="font-size:14px; overflow: hidden; height:180px;">{{description}}</div>
                </v-col>
                <v-col align="end" justify="end">
                    <img width="120rem" src="https://i.pinimg.com/originals/26/ea/fc/26eafc0b14488fea03fa8fa9751203ff.jpg">
                </v-col>   
            </v-row>
            <div align="start"><v-btn color="#920825" class="#920825--text ml-5" outlined :to="'/termek/'+id">Tovább</v-btn></div>
        </v-card>
    </div>    
</template>
<script>
export default{
     data(){
        return{
            dialog: false,
            modify: false,
            detail:false,
            title_length: this.product_name.length
        }
    },
    props:{
        id:{
            type:Number
        },
        type_id:{
            type:Number
        },
        product_name:{
            type:String,
            default:""
        },
        description:{
            type:String
        },
        index_picture:{
            type:String
        },
        admin:{
            type:Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
img {
  max-width: 100%
}

.image {
  flex-basis: 150%
}
 .aligned {
            display: flex;
            align-items: center;
        }

</style>